import {CLEAR_GANT_REPRESENTATION} from "../../../enums/Employees/employees.types";

export const clearGantRepresentationAction = () => {
    return {
        type: CLEAR_GANT_REPRESENTATION,
    };
};
